import React from "react";
import { HeadConsult } from "./Head";
import { ClinicalEvaluationScreen } from "./Steps/ClinicalEvaluationScreen";
import { ClinicalEvaluationRecord } from "./Steps/ClinicalEvaluationRecord";
import { useClinicalEvaluation } from "shared/providers/ClinicalEvaluation";

const ClinicalEvaluationStep: React.FC = () => {
  const { step } = useClinicalEvaluation();

  const stepTitle = [
    step === 1 && "1 de 2 - Avaliação Clínica",
    step === 2 && "2 de 2 - Ficha Clínica",
  ];

  return (
    <>
      <HeadConsult title={stepTitle}>
        {step === 1 && <ClinicalEvaluationScreen />}
        {step === 2 && <ClinicalEvaluationRecord />}
      </HeadConsult>
    </>
  );
};

export { ClinicalEvaluationStep };
